import { LoyaltyCard, Discount } from '@src/graphql-types'
import { LoyaltyCardStamp } from '@src/components/SingleOutlet/types'
import { UseBasketTotalsResponseData } from '../../../hooks/useTotals/useBasketTotals'

export const calculatePotentialToEarnOnOrder = (
  basketTotals: UseBasketTotalsResponseData | undefined,
  loyaltyCard:
    | (Pick<
        LoyaltyCard,
        | 'requiredStamps'
        | 'discountStrategy'
        | 'allowCashOrders'
        | 'isAvailableToday'
        | 'loyaltyCardColor'
        | 'loyaltyCardIcon'
        | 'netTotal'
      > & {
        discount: Pick<
          Discount,
          'discountAmount' | 'discountPercentage' | 'minimumSubtotalGross'
        >
      } & { loyaltyCardStamps: LoyaltyCardStamp[] })
    | null
) => {
  if (!loyaltyCard) return 0

  const { discount } = loyaltyCard

  let calculationTotal = 0
  if (!basketTotals?.checkoutBasketTotals) {
    calculationTotal = basketTotals?.basketItemsTotal ?? 0
  } else {
    const appliedDiscountReductionAmount =
      basketTotals.checkoutBasketTotals?.appliedDiscount?.reductionAmount ?? 0

    // Calculate the basket item total without fees and applied discounts
    calculationTotal =
      loyaltyCard.discountStrategy === 'WHOLE_ORDER_DISCOUNT'
        ? basketTotals.checkoutBasketTotals.sumTotal // total
        : basketTotals.checkoutBasketTotals.nonAddOnBasketItemsTotal -
          appliedDiscountReductionAmount // subtotal
  }

  // If the total without fees is less than or equal to 0 and there is a discount percentage, return 0
  if (
    calculationTotal <= 0 &&
    discount?.discountPercentage &&
    discount.discountPercentage !== 0
  ) {
    return 0
  }

  let potentialSaving = 0

  // Calculate potential saving based on discount amount or percentage
  if (discount?.discountAmount && discount.discountAmount !== 0) {
    potentialSaving = discount.discountAmount
  } else if (
    discount?.discountPercentage &&
    discount.discountPercentage !== 0
  ) {
    potentialSaving = calculationTotal * (discount.discountPercentage / 100)
  }

  return potentialSaving || 0
}
